import { isEmpty } from 'lodash';
import { useMemo } from 'react';

import {
  TemplateEntryAppointmentItemDataFragment,
  TemplateEntryItemDataFragment,
} from '../../data/types/api/graphql';
import { ButtonIcon } from '../button/button';
import { CustomFormattedMessage } from '../intl/custom-formatted-message';
import { TemplateEntryListItem } from './template-entry-list-item';

type TemplateEntryListProps = {
  loading?: boolean;
  items: TemplateEntryItemDataFragment[];
  actions?: {
    icon?: ButtonIcon;
    onClick: (value: string) => void;
  }[];
  onClick?: (
    value:
      | TemplateEntryItemDataFragment
      | TemplateEntryAppointmentItemDataFragment
  ) => void;
};

export function TemplateEntryList({
  loading = false,
  actions = [],
  onClick,
  ...props
}: TemplateEntryListProps) {
  const items = useMemo(() => props.items, [props.items]);

  if (loading) {
    return (
      <p>
        <CustomFormattedMessage id="common.loading" />
      </p>
    );
  }

  if (isEmpty(items)) {
    return (
      <p>
        <CustomFormattedMessage id="template.no-template-details" />
      </p>
    );
  }

  return (
    <div className="content-list">
      {items.map(option => (
        <div key={option.id} className="content-list__item">
          <TemplateEntryListItem
            templateEntryItem={option}
            actions={actions}
            onClick={onClick}
          />
        </div>
      ))}
    </div>
  );
}
